import React from 'react';
import Loadable from 'react-loadable';
import Loading from 'components/Loading';
import Translate from 'components/translate';

const ManageHomeOwners = Loadable({
  loader: () => import('./Containers/manage-home-owners'),
  loading: Loading
});

const ViewAssignedLot = Loadable({
  loader: () => import('./Containers/view-assigned-lot'),
  loading: Loading
});

export default [
  {
    path: '/home-owners',
    component: ManageHomeOwners,
    private: true,
    name: 'Home owners',
    portal: ['Builder'],
    role: ['SystemPowerUser'],
    menu: {
      name: <Translate translateKey='homeowner' plurals capitalize />,
      icons: 'icon-homeowners-ic',
      order: 11
    }
  },
  {
    path: '/home-owners/:homeownerId/assigned-lot',
    component: ViewAssignedLot,
    private: true
  }
];



// WEBPACK FOOTER //
// ./src/HomeOwners/routes.js